var map = {
	"./footer.de-CH.json": 1062,
	"./footer.de-DE.json": 1063,
	"./footer.en-CA.json": 1064,
	"./footer.en-GB.json": 1065,
	"./footer.en-IN.json": 1066,
	"./footer.en-ME.json": 1067,
	"./footer.en-US.json": 1068,
	"./footer.es-EM.json": 1069,
	"./footer.es-ES.json": 1070,
	"./footer.fr-BE.json": 1071,
	"./footer.fr-CA.json": 1072,
	"./footer.fr-CH.json": 1073,
	"./footer.nl-BE.json": 1074,
	"./footer.nl-NL.json": 1075,
	"./footer.pl-PL.json": 1076,
	"./footer.pt-BR.json": 1077
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1061;